import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import './RightPaletteLouveredWallMenu.scss';
import SelectionSupplier from '../SelectionSuplier/SelectionSuplier';
import CardMaterial from '../CardMaterial/CardMaterial';
import RightSupplierMenu from '../RightSupplierMenu/RightSupplierMenu';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPriceTexture,
  fetchTextures,
} from '../../../../store/actions/texture.action';
import { DesignerPageContext } from '../../DesignerPage';
import InfiniteScroll from '../../../../components/common/InfiniteScroll/InfiniteScroll';
import { InsideType } from '../../../../constants/enum';
import SearchComponent from '../../../../components/common/SearchComponent/SearchComponent';
import { openMessageError } from '../../../../components/common/Message/openMessageError';
import {
  closeNotification,
  openNotification,
} from '../../../../components/common/Notification/openNotification';
import { checkTextureType } from '../../../../utils/modules/ModuleUtils';
import { useTranslation } from 'react-i18next';
import { setCurrentSupplier } from '../../../../store/reducers/supplier.reducer';
import { TabSpecialTexture } from '../TabSpecialTexture/TabSpecialTexture';

const RightPaletteLouveredWallMenu = ({ open, onClose, title }) => {
  // const [openSupplier, setOpenSupplier] = useState(false);
  // const [textureType, setTextureType] = useState();

  const { renderSupplierMenu, renderContent } = open ? RenderContent() : {};
  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-start gap-8">
            <ButtonIconGhostMedium
              icon={<Icon.ICArrowBack />}
              onClick={onClose}
            />
            <span className="text-title-large">{title}</span>
          </div>
        }
        content={renderContent?.()}
      />
      {renderSupplierMenu?.()}
      {/* <RightSupplierMenu
        open={openSupplier}
        onClose={supplier => {
          setOpenSupplier(false);
          if (!supplier && open) onClose?.();
        }}
        // setSupplierId={setSupplierId}
        // supplierId={supplierId}
        type="louveredWall"
      /> */}
    </>
  );
};

export default RightPaletteLouveredWallMenu;

const RenderContent = () => {
  const { selectedModels, selectedModel, sceneManager } =
    useContext(DesignerPageContext);
  const { t } = useTranslation();
  const [texture, setTexture] = useState();
  const [search, setSearch] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState();
  const [supplier, setSupplier] = useState();
  const [textureType, setTextureType] = useState();

  const dispatch = useDispatch();
  const { textures, specialTextures } = useSelector(state => state.texture);
  const {
    suppliers,
    currentSupplier: { louveredWall: supplierId },
  } = useSelector(state => state.supplier);

  const { specialTab, setSpecialTab, renderContent, renderSupplierMenu } =
    TabSpecialTexture({
      supplierId,
      supplier,
      setSupplier,
      suppliers,
      textureType,
      // setOpenSupplier,
      type: 'louveredWall',
      texture,
      setTexture,
    });

  const traverseColorAndTexture = useCallback(
    selectedModel => {
      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      if (modules && selectedModel) {
        let supplierIds = { ...supplierId };

        const moduleEntries = Array.from(modules.entries());
        const module = moduleEntries?.find(
          ([item, value]) => value.group.uuid === selectedModel?.uuid
        );

        let tempTextureFrame = null;
        let tempTextureDoor = null;
        let tempTextureLouveredWall = null;
        moduleEntries.forEach(([item, value]) => {
          if (value?.textures.get('frame')) {
            tempTextureFrame = value?.textures.get('frame');
          }
          if (value?.textures.get('DOOR')) {
            tempTextureDoor = value?.textures.get('DOOR');
          }
          if (
            value?.textures.get('VACH-LAM') ||
            value?.textures.get('VACH-TRON') ||
            value?.textures.get('VACH-GUONG')
          ) {
            tempTextureLouveredWall =
              value?.textures.get('VACH-LAM') ??
              value?.textures.get('VACH-TRON') ??
              value?.textures.get('VACH-GUONG');
          }
        });

        if (module) {
          const [item, value] = module;

          const textureLouveredWall =
            value?.textures.get('VACH-LAM') ??
            value?.textures.get('VACH-TRON') ??
            value?.textures.get('VACH-GUONG');
          supplierIds = {
            id:
              textureLouveredWall?.supplier?.id ??
              tempTextureLouveredWall?.supplier?.id ??
              tempTextureFrame?.supplier?.id ??
              tempTextureDoor?.supplier?.id ??
              supplierIds?.id,
            materialType:
              textureLouveredWall?.supplier?.materialType ??
              tempTextureLouveredWall?.supplier?.materialType ??
              tempTextureFrame?.supplier?.materialType ??
              tempTextureDoor?.supplier?.materialType ??
              supplierIds?.materialType,
            special:
              textureLouveredWall?.specialTexture ??
              supplierIds?.special ??
              tempTextureLouveredWall?.specialTexture ??
              tempTextureFrame?.specialTexture ??
              tempTextureDoor?.specialTexture ??
              textureType?.split(',').includes('M'),
          };

          if (supplierIds?.id) {
            dispatch(setCurrentSupplier({ louveredWall: supplierIds }));
          }

          if (textureLouveredWall?.textureId) {
            setTexture({
              materialType: textureLouveredWall.supplier?.name ?? '--',
              name: textureLouveredWall.textureCode ?? t('Not selected'),
              src: textureLouveredWall.textureUrl,
              textureId: textureLouveredWall.textureId,
              // special: specialTexture
            });
          } else {
            setTexture();
          }
        }
      }
    },
    [selectedModel, supplierId, sceneManager, textureType]
  );

  const changeTextureLouveredWall = useCallback(
    async (texturePrice, item, applyToAll, materialType) => {
      if (!texturePrice.some(item => item.thickness === 17)) {
        openNotification({
          key: 'texture-louvered-wall-error',
          icon: <Icon.ICWarning />,
          title: t('The color code cannot be applied!'),
          description: t(
            'Please select a new color code, this color code does not support a thickness of {{x}}mm.',
            { x: 17 }
          ),
          duration: 2,
        });
        return;
      }
      closeNotification('texture-louvered-wall-error');
      const textureController = sceneManager.textureController;
      const applyTexture = async ({
        module,
        texture = {
          textureId: item.id,
          textureCode: item.code,
          material: materialType,
          texturePrice: {
            0.017: texturePrice.find(item => item.thickness === 17)?.price || 0,
            0.008: texturePrice.find(item => item.thickness === 8)?.price || 0,
          },
          no_grain: item.group_name === 'no_grain',
          url: item.image,
          supplier: {
            ...(texturePrice.supplier ?? {}),
            ...(supplierId ?? {}),
            materialType,
            name: item.supplier_name,
            special: specialTab === 'special',
            ...(item.supplier ?? {}),
          },
          special: item.special && materialType === 'M',
        },
        includeMeshes = [
          'VACH-TRON',
          'VACH-GUONG',
          'VACH-LAM',
          'LAM_BASE',
          'LAM_SLAT',
        ],
      }) => {
        return await textureController.changeTexture({
          module,
          textureType: 'map',
          texture,
          includeMeshes,
        });
      };

      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      const moduleEntries = Array.from(modules.entries());

      if (applyToAll && selectedModel) {
        const len = moduleEntries?.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            const [key, value] = moduleEntries[i];
            const model = value.group;
            if (
              ['lower', 'upper', 'ceiling'].some(
                item =>
                  model?.userData?.moduleType?.includes(item) &&
                  selectedModel?.userData?.moduleType?.includes(item)
              )
            )
              await applyTexture({
                module: value,
              });
          }
        }
      } else {
        const len = selectedModels.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            const model = selectedModels[i];
            const [item, value] = moduleEntries?.find(
              ([item, value]) => value.group.uuid === model.uuid
            );
            await applyTexture({ module: value });
          }
        }
      }
    },
    [sceneManager, selectedModel, supplierId, selectedModels, specialTab]
  );

  const handleClick = useCallback(
    async (item, func, applyToAll) => {
      const materialType =
        specialTab === 'special' ? 'M' : supplierId?.materialType;
      // const materialType =
      //   typeMaterial === 'M'
      //     ? 'Melamine-coated MDF'
      //     : typeMaterial === 'L'
      //       ? 'Moisture-resistant MDF'
      //       : typeMaterial;
      if (item.image) {
        dispatch(
          fetchPriceTexture({
            catalogId: item.id,
            type: materialType,
          })
        ).then(async action => {
          if (action.payload.data) {
            const { data } = action.payload;
            await changeTextureLouveredWall(
              data,
              item,
              applyToAll,
              materialType
            );

            await sceneManager.calculateTotalCost({});
            traverseColorAndTexture(selectedModel);
            func();
          }
        });
      } else {
        openMessageError({
          content: t('The texture has no data, please select another texture.'),
        });
      }
    },
    [
      supplierId,
      changeTextureLouveredWall,
      sceneManager,
      traverseColorAndTexture,
      selectedModel,
      specialTab,
    ]
  );

  const loadMoreData = useCallback(async () => {
    const {
      preParams: { offset, limit },
    } = textures;
    try {
      if (supplierId)
        dispatch(
          fetchTextures({
            offset: offset + limit,
            limit,
            supplier: supplierId.id,
            priceCollectionTypes: supplierId?.materialType,
            kw: debouncedSearch,
          })
        ).then(action => {});
    } catch (e) {
      openMessageError({ content: t('Failed to load texture data.') });
    }
  }, [supplierId, debouncedSearch, textures]);
  // Debounce searchTerm
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // Đợi 500ms sau khi user ngừng gõ

    // Cleanup: Clear timer nếu user gõ tiếp
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    // loadMoreData();
    if (supplierId && specialTab === 'normal') {
      const {
        preParams: { supplier, priceCollectionTypes, kw },
      } = textures;
      if (
        supplier !== supplierId?.id ||
        supplierId?.materialType !== priceCollectionTypes ||
        kw !== debouncedSearch
      )
        if (supplierId) {
          dispatch(
            fetchTextures({
              offset: 0,
              limit: 20,
              supplier: supplierId?.id,
              priceCollectionTypes: supplierId?.materialType,
              kw:
                debouncedSearch?.trim() === ''
                  ? undefined
                  : debouncedSearch?.trim(),
            })
          );
        }
    }
  }, [debouncedSearch, supplierId, specialTab]);

  useEffect(() => {
    if (selectedModel) {
      traverseColorAndTexture(selectedModel);
      setTextureType(checkTextureType(selectedModels, 'louveredWall'));
    }
  }, [selectedModel]);

  return {
    renderSupplierMenu: renderSupplierMenu,
    renderContent: () => {
      return (
        <>
          <div
            key={1}
            className="flex p-16 flex-col items-start gap-8 self-stretch bg-fills-white"
          >
            {renderContent()}

            <div className="flex justify-between items-center self-stretch">
              <SearchComponent
                size="small"
                style={{ width: '100%' }}
                value={search}
                setValue={setSearch}
              />
            </div>
          </div>

          <div
            key={4}
            className="flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
            style={{ backgroundColor: '#F7F7F7' }}
          >
            <div
              id="right-palete-menu"
              className="flex flex-col self-stretch grow overflow-scroll"
            >
              {specialTab === 'special' ? (
                <InfiniteScroll
                  dataLength={specialTextures.data.length}
                  next={loadMoreData}
                  hasMore={specialTextures.data.length < specialTextures.total}
                  scrollableTarget={'right-palete-louvered-wall-menu'}
                  className="flex flex-row flex-wrap gap-2"
                >
                  {specialTextures.data.map((item, index) => {
                    return (
                      <CardMaterial
                        key={item.id}
                        item={{
                          title: item.code,
                          description:
                            item.price_group_name ?? item.supplier_name,
                          src: item.icon,
                          detailLink: item.detail_link,
                          productDemo: item.product_demo,
                        }}
                        active={texture && item.id === texture.textureId}
                        onClick={async (func, applyToAll) =>
                          await handleClick(item, func, applyToAll)
                        }
                      />
                    );
                  })}
                </InfiniteScroll>
              ) : null}
              {specialTab === 'normal' ? (
                <InfiniteScroll
                  dataLength={textures.data.length}
                  next={loadMoreData}
                  hasMore={textures.data.length < textures.total}
                  scrollableTarget={'right-palete-louvered-wall-menu'}
                  className="flex flex-row flex-wrap gap-2"
                >
                  {textures.data.map((item, index) => {
                    return (
                      <CardMaterial
                        key={item.id}
                        item={{
                          title: item.code,
                          description:
                            item.price_group_name ?? item.supplier_name,
                          src: item.icon,
                        }}
                        active={texture && item.id === texture.textureId}
                        onClick={async (func, applyToAll) =>
                          await handleClick(item, func, applyToAll)
                        }
                      />
                    );
                  })}
                </InfiniteScroll>
              ) : null}
            </div>
          </div>
        </>
      );
    },
  };
};
